import { __ } from '@wordpress/i18n';
import { setupLocationVisibility } from './cityFilter';
import { initAdministrationMembershipSection } from './membershipRepeater';

const GROUPS = [
	{
		label: __( 'Basic information', 'anacrm' ),
		description: __(
			'Description, sector, geographical scope, work scope, keywords, NIF.',
			'anacrm'
		),
		open: false,
		fields: [
			'_ad_description',
			'_ad_sector',
			'_ad_geoscope',
			'_ad_administration_upper',
			'_ad_administration_lower',
			'_ad_work_scope',
			'_ad_keyword',
			'_ad_nif',
			'_ad_image',
		],
	},
	{
		label: __( 'Location', 'anacrm' ),
		description: __( 'Territory, city, address.', 'anacrm' ),
		fields: [
			'_ad_location',
			'_ad_territory',
			'_ad_region',
			'_ad_city',
			'_ad_address',
		],
	},
	{
		label: __( 'Contact', 'anacrm' ),
		description: __(
			'Contact person, email, phone, website, Social networks.',
			'anacrm'
		),
		fields: [
			'_ad_person_ref',
			'_ad_space_ref',
			'_ad_contact_mail',
			'_ad_contact_phone',
			'_ad_contact_website',
			'_ad_contact_social',
		],
	},
	{
		label: __( 'Responsible public procurement', 'anacrm' ),
		description: __(
			'Amount of tenders, special budget, percentage of special budget',
			'anacrm'
		),
		fields: [
			'_ad_tender_2025',
			'_ad_special_budget_2025',
			'_ad_budget_percentage_cpr',
		],
	},
];

function findFieldWrapper( form, name ) {
	const dashedName = name.replace( /_/g, '-' );
	return form.querySelector( `.pods-form-ui-row-name-${ dashedName }` );
}

function buildAccordion( form ) {
	for ( const group of GROUPS ) {
		const fieldWrappers = group.fields
			.map( ( f ) => findFieldWrapper( form, f ) )
			.filter( Boolean );
		if ( ! fieldWrappers.length ) {
			continue;
		}

		const parent = fieldWrappers[ 0 ].parentElement;

		const details = document.createElement( 'details' );
		if ( group.open ) {
			details.open = true;
		}
		details.className = 'mb-4 border-2 border-green';

		const summary = document.createElement( 'summary' );
		summary.className =
			'px-4 py-3 cursor-pointer select-none bg-green/30 hover:bg-green/60 marker:float-left';
		const summaryTit = document.createElement( 'h2' );
		summaryTit.className = 'text-base font-semibold inline-block';
		summaryTit.textContent = group.label;
		summary.appendChild( summaryTit );
		const summaryDesc = document.createElement( 'p' );
		summaryDesc.textContent = group.description ?? '';
		summary.appendChild( summaryDesc );
		details.appendChild( summary );

		const body = document.createElement( 'div' );
		body.className = 'px-4 py-2 bg-green/10';
		details.appendChild( body );

		parent.insertBefore( details, fieldWrappers[ 0 ] );
		fieldWrappers.forEach( ( w ) => body.appendChild( w ) );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const wrapper = document.querySelector(
		'.anacrm-administration-form-accordion'
	);
	if ( ! wrapper ) {
		return;
	}

	const successDiv = wrapper.querySelector( '.pods-form-front-success' );
	if ( successDiv ) {
		const btn = document.createElement( 'button' );
		btn.type = 'button';
		btn.className = 'px-3 py-2 text-2xl hover:text-yellow cursor-pointer';
		btn.innerHTML = '&times;';
		btn.addEventListener( 'click', () => successDiv.remove() );
		successDiv.appendChild( btn );
	}

	const form = wrapper.querySelector( 'form' );
	if ( ! form ) {
		return;
	}

	let done = false;

	function tryBuild() {
		if ( done ) {
			return;
		}
		if ( ! form.querySelector( '.pods-field__container' ) ) {
			return;
		}
		done = true;
		observer.disconnect();
		buildAccordion( form );
		setupLocationVisibility( form, {
			locationField: '_ad_location',
			territoryField: '_ad_territory',
			regionField: '_ad_region',
			cityField: '_ad_city',
			addressField: '_ad_address',
		} );

		const administrationId = wrapper.dataset.administrationId ?? '';
		const isNew = wrapper.dataset.isEdit === '0';

		const details = document.createElement( 'details' );
		details.className = 'mb-4 border-2 border-green';

		const summary = document.createElement( 'summary' );
		summary.className =
			'px-4 py-3 cursor-pointer select-none bg-green/30 hover:bg-green/60 marker:float-left';
		const summaryTit = document.createElement( 'h2' );
		summaryTit.className = 'text-base font-semibold inline-block';
		summaryTit.textContent = __(
			'Who are the people associated with the administration?',
			'anacrm'
		);
		summary.appendChild( summaryTit );
		const summaryDesc = document.createElement( 'p' );
		summaryDesc.textContent = '';
		summary.appendChild( summaryDesc );
		details.appendChild( summary );

		const body = document.createElement( 'div' );
		body.className = 'px-4 py-2 bg-green/10';
		details.appendChild( body );

		const submittableFields = form.querySelector(
			'.pods-submittable-fields'
		);
		const submitRow = submittableFields
			? submittableFields.querySelector( '.pods-submit' )
			: null;
		if ( submitRow ) {
			submittableFields.insertBefore( details, submitRow );
		} else if ( submittableFields ) {
			submittableFields.appendChild( details );
		} else {
			form.appendChild( details );
		}

		initAdministrationMembershipSection( body, administrationId, isNew );
	}

	let debounceTimer = null;
	const observer = new MutationObserver( () => {
		clearTimeout( debounceTimer );
		debounceTimer = setTimeout( tryBuild, 300 );
	} );

	observer.observe( form, { childList: true, subtree: true } );

	tryBuild();
} );
